<p-dialog
    [modal]="true"
    [contentStyle]="{ 'min-width': '800px', overflow: 'visible' }"
    [maximizable]="true"
    [header]="'Cadastro da Versão'"
    [(visible)]="modalVisible"
    styleClass="w-200 max-w-[90%]"
>
    <div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
        <app-select
            class="w-full md:max-w-1/2"
            label="Solução"
            [options]="selectSolucao"
            formControlName="IdSolucao"
        >
        </app-select>

        <div
            class="w-full grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 items-end"
        >
            <app-input-double
                [label]="'Número da Versão'"
                formControlName="VersaoNumero"
            ></app-input-double>

            <app-input
                [label]="'Versão'"
                formControlName="VersaoString"
            ></app-input>

            <app-checkbox
                [label]="'Obrigatório'"
                formControlName="Obrigatoria"
                binary="true"
            ></app-checkbox>

            <app-checkbox
                [label]="'Com Atualização'"
                formControlName="ComAtualizador"
                binary="true"
            ></app-checkbox>
        </div>

        <app-input
            [label]="'Descrição'"
            formControlName="Descricao"
            class="w-full md:max-w-1/2"
        ></app-input>

        <app-footer-page
            [end]="true"
            (confirmar)="processarFormulario()"
            (cancelar)="fecharModal()"
            labelConfirmar="Gerar"
        >
        </app-footer-page>
    </div>

    @if (exibirLoader | async) {
        <div
            style="
                position: fixed;
                width: 100vw;
                height: 100vh;
                top: 0;
                left: 0;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(255, 255, 255, 0.4);
            "
        >
            <p-progressSpinner></p-progressSpinner>
        </div>
    }

    @if (exibirLoaderNetwork | async) {
        <div
            style="
                position: fixed;
                width: 100vw;
                height: 100vh;
                top: 0;
                left: 0;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(255, 255, 255, 0.4);
            "
        >
            <p-progressSpinner></p-progressSpinner>
        </div>
    }
</p-dialog>
